import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CancelOrderModal } from '../CancelOrderModal';
export function EmissorCancelOrderModal({ flow, dataTestId }) {
    return (_jsx(CancelOrderModal, { isOpen: flow.isCancelModalOpen, onClose: flow.closeCancelModal, onConfirm: flow.confirmCancelOrder, isLoading: flow.isCanceling, dataTestId: dataTestId }));
}
